"use strict";
/**
 * The UI translation catalog: every locale's string map, composed from the
 * JSON bundles in this folder.
 *
 * Each locale layers its bundles in a fixed order — machine, then human, then
 * deviant, then silo overrides — so a later layer wins. Regional variants
 * (`fr-CA`, `fr-BE`, the Swiss locales) start from their base language's
 * bundles and spread their own on top, so a key missing from the variant falls
 * back to the base. Silo bundles are prefixed with `<silo>:` by
 * `namespaceKeys` and looked up first by `translateLabel`.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.allTranslations = void 0;
exports.addTestTranslations = addTestTranslations;
exports.checkForDeviantTranslations = checkForDeviantTranslations;
exports.namespaceKeys = namespaceKeys;
const ui_deviant_de_DE_json_1 = __importDefault(require("./devianttranslations/ui_deviant_de-DE.json"));
const ui_human_de_CH_json_1 = __importDefault(require("./humantranslations/ui_human_de-CH.json"));
const ui_human_de_DE_json_1 = __importDefault(require("./humantranslations/ui_human_de-DE.json"));
const ui_human_fr_BE_json_1 = __importDefault(require("./humantranslations/ui_human_fr-BE.json"));
const ui_human_fr_CA_json_1 = __importDefault(require("./humantranslations/ui_human_fr-CA.json"));
const ui_human_fr_CH_json_1 = __importDefault(require("./humantranslations/ui_human_fr-CH.json"));
const ui_human_fr_FR_json_1 = __importDefault(require("./humantranslations/ui_human_fr-FR.json"));
const ui_human_it_CH_json_1 = __importDefault(require("./humantranslations/ui_human_it-CH.json"));
const ui_human_it_IT_json_1 = __importDefault(require("./humantranslations/ui_human_it-IT.json"));
const ui_human_nl_NL_json_1 = __importDefault(require("./humantranslations/ui_human_nl-NL.json"));
const ui_human_rm_CH_json_1 = __importDefault(require("./humantranslations/ui_human_rm-CH.json"));
const ui_machine_de_CH_json_1 = __importDefault(require("./machinetranslations/ui_machine_de-CH.json"));
const ui_machine_de_DE_json_1 = __importDefault(require("./machinetranslations/ui_machine_de-DE.json"));
const ui_machine_fr_BE_json_1 = __importDefault(require("./machinetranslations/ui_machine_fr-BE.json"));
const ui_machine_fr_CA_json_1 = __importDefault(require("./machinetranslations/ui_machine_fr-CA.json"));
const ui_machine_fr_CH_json_1 = __importDefault(require("./machinetranslations/ui_machine_fr-CH.json"));
const ui_machine_fr_FR_json_1 = __importDefault(require("./machinetranslations/ui_machine_fr-FR.json"));
const ui_machine_it_CH_json_1 = __importDefault(require("./machinetranslations/ui_machine_it-CH.json"));
const ui_machine_it_IT_json_1 = __importDefault(require("./machinetranslations/ui_machine_it-IT.json"));
const ui_machine_nl_NL_json_1 = __importDefault(require("./machinetranslations/ui_machine_nl-NL.json"));
const ui_machine_rm_CH_json_1 = __importDefault(require("./machinetranslations/ui_machine_rm-CH.json"));
const ui_ard_de_DE_json_1 = __importDefault(require("./silotranslations/ui_ard_de-DE.json"));
const ui_mdr_de_DE_json_1 = __importDefault(require("./silotranslations/ui_mdr_de-DE.json"));
const ui_srg_de_CH_json_1 = __importDefault(require("./silotranslations/ui_srg_de-CH.json"));
const ui_srg_en_US_json_1 = __importDefault(require("./silotranslations/ui_srg_en-US.json"));
const ui_srg_fr_CH_json_1 = __importDefault(require("./silotranslations/ui_srg_fr-CH.json"));
const ui_srg_it_CH_json_1 = __importDefault(require("./silotranslations/ui_srg_it-CH.json"));
const ui_srg_rm_CH_json_1 = __importDefault(require("./silotranslations/ui_srg_rm-CH.json"));
const ui_zdf_de_DE_json_1 = __importDefault(require("./silotranslations/ui_zdf_de-DE.json"));
const ui_machine_translations_french_canadian = {
    ...ui_machine_fr_FR_json_1.default,
    ...ui_machine_fr_CA_json_1.default,
};
const ui_machine_translations_french_belgian = {
    ...ui_machine_fr_FR_json_1.default,
    ...ui_machine_fr_BE_json_1.default,
};
const ui_human_translations_french_canadian = {
    ...ui_human_fr_FR_json_1.default,
    ...ui_human_fr_CA_json_1.default,
};
const ui_human_translations_french_belgian = {
    ...ui_human_fr_FR_json_1.default,
    ...ui_human_fr_BE_json_1.default,
};
const ui_machine_translations_french = ui_machine_fr_FR_json_1.default;
const ui_machine_translations_german = ui_machine_de_DE_json_1.default;
const ui_machine_translations_italian = ui_machine_it_IT_json_1.default;
const ui_human_translations_french = ui_human_fr_FR_json_1.default;
const ui_human_translations_german = ui_human_de_DE_json_1.default;
const ui_human_translations_italian = ui_human_it_IT_json_1.default;
const ui_deviant_translations_german = ui_deviant_de_DE_json_1.default;
const ui_mdr_german_namespaced = namespaceKeys(ui_mdr_de_DE_json_1.default, 'mdr');
const ui_ard_german_namespaced = namespaceKeys(ui_ard_de_DE_json_1.default, 'ard');
const ui_zdf_german_namespaced = namespaceKeys(ui_zdf_de_DE_json_1.default, 'zdf');
const ui_srg_english_namespaced = namespaceKeys(ui_srg_en_US_json_1.default, 'srg');
const ui_srg_french_swiss_namespaced = namespaceKeys(ui_srg_fr_CH_json_1.default, 'srg');
const ui_srg_german_swiss_namespaced = namespaceKeys(ui_srg_de_CH_json_1.default, 'srg');
const ui_srg_italian_swiss_namespaced = namespaceKeys(ui_srg_it_CH_json_1.default, 'srg');
const ui_srg_romansh_swiss_namespaced = namespaceKeys(ui_srg_rm_CH_json_1.default, 'srg');
exports.allTranslations = {
    'nl-NL': {
        ...ui_machine_nl_NL_json_1.default,
        ...ui_human_nl_NL_json_1.default,
    },
    'en-US': {
        ...ui_srg_english_namespaced,
    },
    'fr-CA': {
        ...ui_machine_translations_french_canadian,
        ...ui_human_translations_french_canadian,
    },
    'fr-BE': {
        ...ui_machine_translations_french_belgian,
        ...ui_human_translations_french_belgian,
    },
    'de-DE': {
        ...ui_machine_translations_german,
        ...ui_human_translations_german,
        ...ui_deviant_translations_german,
        ...ui_mdr_german_namespaced,
        ...ui_ard_german_namespaced,
        ...ui_zdf_german_namespaced,
    },
    'fr-FR': {
        ...ui_machine_translations_french,
        ...ui_human_translations_french,
    },
    'de-CH': {
        ...ui_machine_translations_german,
        ...ui_human_translations_german,
        ...ui_deviant_translations_german,
        ...ui_machine_de_CH_json_1.default,
        ...ui_human_de_CH_json_1.default,
        ...ui_srg_german_swiss_namespaced,
    },
    'rm-CH': {
        ...ui_machine_rm_CH_json_1.default,
        ...ui_human_rm_CH_json_1.default,
        ...ui_srg_romansh_swiss_namespaced,
    },
    'fr-CH': {
        ...ui_machine_fr_FR_json_1.default,
        ...ui_human_fr_FR_json_1.default,
        ...ui_machine_fr_CH_json_1.default,
        ...ui_human_fr_CH_json_1.default,
        ...ui_srg_french_swiss_namespaced,
    },
    'it-IT': {
        ...ui_machine_translations_italian,
        ...ui_human_translations_italian,
    },
    'it-CH': {
        ...ui_machine_it_IT_json_1.default,
        ...ui_human_it_IT_json_1.default,
        ...ui_machine_it_CH_json_1.default,
        ...ui_human_it_CH_json_1.default,
        ...ui_srg_italian_swiss_namespaced,
    },
};
const deviantTranslations = {
    'de-DE': {
        ...ui_deviant_translations_german,
    },
};
function addTestTranslations(translations) {
    Object.keys(translations).forEach((language) => {
        exports.allTranslations[language] = { ...exports.allTranslations[language], ...translations[language] };
    });
}
function checkForDeviantTranslations(language) {
    if (deviantTranslations) {
        let hasDeviantTranslations = false;
        Object.keys(deviantTranslations).forEach((deviantLanguage) => {
            if (deviantLanguage === language) {
                console.error('Deviant translations found in', deviantLanguage, deviantTranslations[deviantLanguage]);
                console.error('Deviant translations lead to product analysis confusion and should be fixed as soon as is practical.');
            }
            hasDeviantTranslations = true;
        });
        if (hasDeviantTranslations) {
            console.warn('Found deviant translations', deviantTranslations);
        }
    }
}
function namespaceKeys(translations, namespace) {
    const namespaced = {};
    for (const key in translations) {
        namespaced[`${namespace}:${key}`] = translations[key];
    }
    return namespaced;
}
//# sourceMappingURL=index.js.map